module.exports = __webpack_public_path__ + "static/media/craft-06.7e8eee05.svg";